import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import selectColumnFactory from "@/react/components/table/components/selectColumnFactory";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import * as yup from "yup";
import {
  CALL_QUEUE_CALLER_ID_OPTIONS,
  CALL_QUEUES,
  CALL_WAIT_PRIORITY_OPTIONS,
  RING_PATTERNS,
  TIME_OUT_OPTIONS,
} from "@/react/features/smp/constants";
import DidNumberSelect from "@/react/features/smp/cells/DidNumberSelect";
import BranchNameSelect from "@/react/features/smp/cells/BranchNameSelect";
import TimezoneSelect from "@/react/features/smp/cells/TimezoneSelect";
import LocaleSelect from "@/react/features/smp/cells/LocaleSelect";
import rgcqMemberColumnsGenerator from "@/react/features/smp/rgcqMemberColumnsGenerator";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.subscriptionId, "Subscription ID"),
        type: TYPES.ID,
      },
      {
        ...getColumnDef(schema.fields.name, "Name"),
        type: TYPES.STRING,
        customCell: ({ getValue }) => <strong>{getValue()}</strong>,
        editable: true,
        sticky: true,
      },
      {
        ...getColumnDef(schema.fields.branchName, "Branch Name"),
        editable: true,
        editableCell: BranchNameSelect,
      },
      {
        ...getColumnDef(schema.fields.primaryDidNumber, "Primary Phone Number"),
        editable: true,
        editableCell: DidNumberSelect,
      },
      {
        ...getColumnDef(schema.fields.extensionNumber, "Extension"),
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.locale, "Locale"),
        editable: true,
        editableCell: LocaleSelect,
      },
      {
        ...getColumnDef(schema.fields.timeZoneId, "Timezone"),
        editable: true,
        editableCell: TimezoneSelect,
      },
      {
        ...getColumnDef(yup.reach(schema, "details.autoLogin"), "Auto Login"),
        editable: true,
        type: TYPES.BOOLEAN,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.callWaitPriority"),
          "Call Wait Priority"
        ),
        editable: true,
        type: TYPES.SELECT,
        options: CALL_WAIT_PRIORITY_OPTIONS,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.callerIdOption"),
          "Caller ID Option"
        ),
        editable: true,
        type: TYPES.SELECT,
        options: CALL_QUEUE_CALLER_ID_OPTIONS,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.enableVoiceMail"),
          "Enable Voice Mail"
        ),
        editable: true,
        type: TYPES.BOOLEAN,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.voiceMailPassword"),
          "Voice Mail Password"
        ),
        editable: true,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.maxQueueSize"),
          "Max Queue Size"
        ),
        editable: true,
        type: TYPES.NUMBER,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.musicTimeOut"),
          "Music Time Out"
        ),
        editable: true,
        type: TYPES.NUMBER,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.ringNoAnswerPause"),
          "Ring No Answer Pause"
        ),
        editable: true,
        type: TYPES.NUMBER,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.ringPattern"),
          "Ring Pattern"
        ),
        editable: true,
        type: TYPES.SELECT,
        options: RING_PATTERNS,
      },
      {
        ...getColumnDef(yup.reach(schema, "details.ringTimer"), "Ring Timer"),
        editable: true,
        type: TYPES.NUMBER,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.systemSupportedMaxQueueSizeLimit"),
          "Supported Max Queue Size Limit"
        ),
        editable: true,
        type: TYPES.NUMBER,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.timeOutOption"),
          "Time Out Option"
        ),
        editable: true,
        type: TYPES.SELECT,
        options: TIME_OUT_OPTIONS,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.wrapUpDelay"),
          "Wrap Up Delay"
        ),
        editable: true,
        type: TYPES.NUMBER,
      },

      ...rgcqMemberColumnsGenerator(schema, CALL_QUEUES),
    ].map(mapColumnTypes)
  );

export default columnDefinition;
